import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { RegisterForm } from '@/features/auth';

import styles from '@/pages/auth.module.css';

export function RegisterPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section className={styles.page}>
      <h1 className={styles.title}>{t('auth.signUpTitle')}</h1>
      <RegisterForm onSuccess={() => void navigate('/app', { replace: true })} />
    </section>
  );
}
